import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var UpdateDesignationRes;
export const UpdateDesignationTodo = createAsyncThunk('UpdateDesignation', async (data) => {
    console.log(data)
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL +  `superadmin/designation/${data?.id}`,
            data: {
                "name": data?.designation,
                "status": data?.status,
                "modified_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdateDesignationRes = res.data

    } catch (error) {
        return UpdateDesignationRes = error.response.data
    }
})